//STYLES
import styles from "./RightNavbar.module.scss";

//HOOKS
import { useContext } from "react";

//CONTEXT
import NavContext from "../../context/NavContext";

//ICONS , IMAGES
import { MdOutlineMenu } from "react-icons/md";

//Components
import MyProfile from "./Submenus/MyProfile";
import Support from "./Submenus/Support";

//IMG
import logo from "../../pics/logo-hearingspace.png";

const RightNavbar = ({ socket }) => {
  const { nav, setNav } = useContext(NavContext);

  return (
    <div className={styles.container}>
      {/* BURGER */}
      <img className={styles.centralLogo} src={logo} alt="" />

      {process.env.REACT_APP_API_URL.includes("localhost") && (
        <span>LOCALHOST</span>
      )}
      {process.env.REACT_APP_API_URL.includes("beta") && <span>BETA</span>}

      <div
        className={styles.burger_container}
        onClick={() => {
          setNav(!nav);
        }}
      >
        <MdOutlineMenu />
      </div>

      {/* ACTIONS */}
      <div className={styles.actions}>{/* <Support /> */}</div>
      {process.env.REACT_APP_API_URL.includes("localhost") && (
        <span>LOCALHOST</span>
      )}
      {process.env.REACT_APP_API_URL.includes("beta") && <span>BETA</span>}

      {/* My Profile */}
      <MyProfile />
    </div>
  );
};

export default RightNavbar;
